import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { EventTypeEnum } from '../../utils/enums';
import { IEventModel } from '../../utils/interfaces';

@Injectable({
    providedIn: 'root'
})
export class EventBus {
    private sub: Subject<IEventModel> = new Subject<IEventModel>();

    public emit(type: EventTypeEnum, data?: any): void {
        this.sub.next({ type, data });
    }

    public on(type: EventTypeEnum): Observable<IEventModel> {
        return this.sub.asObservable().pipe(filter(v => v.type === type));
    }
}
